/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.3.0",
    versionName: "0.3.0",
    versionChannel: "stable",
    buildDate: "2026-06-14T08:26:54.161Z",
    commitHash: "4d3637f0ab2b0276e00f93a160de545db0f25c66",
};
